var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-widget',{attrs:{"label":_vm.label,"model":_vm.model,"attribute":_vm.attribute,"append":"%","hint":_vm.hint,"type":"number","step":_vm.step,"disabled":_vm.disabled,"rules":_vm.rules},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }